import React from 'react';
import V3Button from 'components/UI/V3/Button/Button';
import classes from './SubmitButton.module.scss';

export interface SubmitButtonProps {
    disabled?: boolean;
    onClick?: () => void;
    isLoading?: boolean;
}

const SubmitButton: React.FC<SubmitButtonProps> = ({ disabled, onClick, isLoading }) => {
    return (
        <V3Button
            onClick={onClick}
            disabled={disabled}
            variant="black"
            size="medium"
            label="Submit"
            isLoading={isLoading}
            className={classes.button}
        />
    );
};

export default SubmitButton;
